var _defs, _clipPath, _path, _defs2, _clipPath2, _path2, _defs3, _clipPath3, _path3, _defs4, _clipPath4, _path4, _defs5, _clipPath5, _path5, _defs6, _clipPath6, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 129 42"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-google_svg__a",
    d: "M15.89 0h1.15c3.98.09 7.9 1.68 10.71 4.51-1.04 1.06-2.1 2.07-3.12 3.13-1.58-1.42-3.48-2.53-5.56-2.91-3.07-.65-6.39-.07-8.96 1.68-2.81 1.84-4.72 4.94-5.13 8.27-.45 3.28.48 6.74 2.62 9.28 2.06 2.48 5.19 4.04 8.44 4.15 3.03.17 6.19-.76 8.4-2.87 1.73-1.49 2.53-3.76 2.79-5.96-3.59 0-7.19.02-10.78 0v-4.45h15.13c.78 4.77-.35 10.15-3.98 13.56-2.42 2.42-5.78 3.84-9.2 4.12-3.31.32-6.73-.3-9.67-1.9C5.2 28.73 2.38 25.56 1 21.83-.3 18.4-.32 14.51.89 11.06c1.1-3.15 3.22-5.94 5.95-7.88C9.46 1.25 12.64.19 15.89 0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-google_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-google_svg__a",
    overflow: "visible"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#logo-google_svg__b)",
    fill: "#3780FF",
    d: "M-5-5h41.81v42.6H-5z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-google_svg__c",
    d: "M102.68 1.12h4.63v30.83c-1.54 0-3.1.02-4.63-.02.02-10.25 0-20.53 0-30.81z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-google_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-google_svg__c",
    overflow: "visible"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#logo-google_svg__d)",
    fill: "#38B137",
    d: "M97.68-3.88h14.63v40.83H97.68z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-google_svg__e",
    d: "M42.53 15.91c-1.17.3-2.25.97-3.03 1.92-2.1 2.5-1.97 6.58.35 8.92 1.32 1.34 3.31 1.96 5.15 1.6 1.71-.3 3.2-1.45 4.03-2.96 1.43-2.57 1.02-6.11-1.17-8.12-1.41-1.29-3.47-1.83-5.33-1.36zm-.65-4.1c2.86-.54 5.95.06 8.31 1.77 2.14 1.51 3.64 3.89 4.09 6.48.58 3-.15 6.28-2.1 8.66-2.1 2.66-5.54 4.08-8.9 3.86-3.07-.17-6.06-1.71-7.88-4.21-2.06-2.76-2.55-6.56-1.43-9.8 1.14-3.48 4.32-6.13 7.91-6.76"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-google_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-google_svg__e",
    overflow: "visible"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#logo-google_svg__f)",
    fill: "#FA3913",
    d: "M28.39 6.62h31.09V37.6H28.39z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-google_svg__g",
    d: "M65.47 15.91c-1.17.3-2.25.97-3.03 1.9-2.08 2.46-1.99 6.48.24 8.83 1.32 1.4 3.38 2.09 5.28 1.71 1.69-.32 3.2-1.45 4.03-2.96 1.41-2.59 1-6.13-1.21-8.14-1.41-1.3-3.47-1.81-5.31-1.34zm-.65-4.1c3.27-.63 6.84.28 9.29 2.57 3.98 3.56 4.42 10.23 1.02 14.33-2.06 2.59-5.39 4.02-8.68 3.86-3.14-.09-6.23-1.64-8.09-4.21-2.1-2.83-2.55-6.71-1.36-10.02 1.18-3.36 4.3-5.93 7.82-6.53"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-google_svg__h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-google_svg__g",
    overflow: "visible"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#logo-google_svg__h)",
    fill: "#FCBD06",
    d: "M51.34 6.62h31.07v30.97H51.34z"
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-google_svg__i",
    d: "M88.76 15.82c-1.32.22-2.55.95-3.4 1.96-2.03 2.42-2.03 6.28.02 8.66 1.17 1.4 3.05 2.18 4.87 1.99 1.71-.17 3.29-1.25 4.13-2.74 1.43-2.53 1.19-5.96-.74-8.16-1.18-1.36-3.08-2.03-4.88-1.71zm-4.48-2.76c2.49-1.55 5.8-1.99 8.48-.65.84.37 1.54.99 2.21 1.62.02-.58 0-1.19.02-1.79 1.45.02 2.9 0 4.37.02V31.3c-.02 2.87-.76 5.92-2.84 8.01-2.27 2.31-5.76 3.02-8.9 2.55-3.35-.5-6.28-2.94-7.58-6.02 1.3-.63 2.66-1.12 4-1.71.76 1.77 2.29 3.28 4.22 3.63 1.93.35 4.16-.13 5.41-1.73 1.34-1.64 1.34-3.89 1.28-5.89-1 .97-2.14 1.84-3.53 2.16-3.01.84-6.32-.19-8.64-2.22-2.34-2.03-3.72-5.16-3.59-8.27.09-3.52 2.08-6.91 5.09-8.75"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-google_svg__j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-google_svg__i",
    overflow: "visible"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#logo-google_svg__j)",
    fill: "#3780FF",
    d: "M74.21 6.62h30.16V47H74.21z"
  })), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "logo-google_svg__k",
    d: "M115.19 18.16c-.74 1.06-1.04 2.35-1.02 3.63 3.14-1.3 6.28-2.59 9.42-3.91-.52-1.21-1.77-1.94-3.05-2.14-2.06-.37-4.2.73-5.35 2.42zm-2.31-4c2.6-2.42 6.6-3.24 9.93-1.96 3.16 1.19 5.17 4.19 6.19 7.28-4.7 1.94-9.37 3.86-14.07 5.81.65 1.23 1.64 2.35 2.99 2.81 1.88.67 4.13.43 5.71-.82.63-.47 1.13-1.1 1.6-1.71 1.19.8 2.38 1.58 3.57 2.37-1.69 2.53-4.52 4.3-7.58 4.58-3.38.41-6.97-.89-9.16-3.52-3.58-4.15-3.23-11.1.82-14.84"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-google_svg__l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#logo-google_svg__k",
    overflow: "visible"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#logo-google_svg__l)",
    fill: "#FA3913",
    d: "M104.59 6.6H134v30.99h-29.41z"
  })));
}

export default SvgLogoGoogle;